import type { ServerLogFilters } from "./server-log.types";

const LEVEL_COLORS: Record<string, string> = {
	warn: "yellow",
	error: "red",
	fatal: "grape",
};
const STATUS_COLORS: Record<string, string> = {
	open: "red",
	resolved: "green",
	ignored: "gray",
	regressed: "orange",
};

export const levelColor = (level: string) => LEVEL_COLORS[level] ?? "gray";
export const statusColor = (status: string) => STATUS_COLORS[status] ?? "gray";

/** Ganti `{kunci}` pada templat teks dengan nilainya. */
export function fill(
	template: string,
	vars: Record<string, string | number>,
): string {
	return template.replace(/\{(\w+)\}/g, (m, k: string) =>
		k in vars ? String(vars[k]) : m,
	);
}

/** Filter UI → query string API (tanpa nilai kosong). */
export function filtersToParams(
	f: ServerLogFilters,
	page?: number,
): URLSearchParams {
	const p = new URLSearchParams();
	if (page) p.set("page", String(page));
	if (f.q.trim()) p.set("q", f.q.trim());
	if (f.level) p.set("level", f.level);
	if (f.module) p.set("module", f.module);
	if (f.status) p.set("status", f.status);
	if (f.range[0]) p.set("from", f.range[0].toISOString());
	if (f.range[1]) {
		const end = new Date(f.range[1]);
		end.setHours(23, 59, 59, 999);
		p.set("to", end.toISOString());
	}
	return p;
}

export function formatDateTime(iso: string | null, locale: string): string {
	if (!iso) return "-";
	return new Date(iso).toLocaleString(locale, {
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}
